import React from 'react';
import { t } from '@lingui/macro';
import Combobox from './primitives/Combobox';
import { ProductCollectionListViewModel } from '../../../../types/internal-api';
import ProductCollections from '../../../pages/sales/products/product-collections/ProductCollections';

export default function ProductCollectionCombobox(props) {
    return (
        <Combobox
            {...props}
            aria-label={t`Product Collections combobox`}
            endpoint="/products/product-collections?pageSize=1000"
            transform={(productCollections: ProductCollectionListViewModel[]) =>
                productCollections.map(productCollection => ({
                    data: productCollection,
                    text: `${productCollection.id} - ${productCollection.name}`,
                    summary: productCollection.name,
                    value: productCollection.id,
                }))
            }
            modal={({ hide, onChange }) => (
                <ProductCollections
                    isComboboxView
                    onSelected={(selected: ProductCollectionListViewModel) => {
                        onChange(selected.id, selected);
                        hide();
                    }}
                />
            )}
        />
    );
}
